import { Injectable } from '@angular/core';
import { IFeaturePermissionProviderService } from '@nimbus-library/features/feature-permission/services/contracts/i-feature-permission-provider.service';
import { IFeatureCollection } from '@nimbus-library/features/feature-permission/models/i-feature-collection.model';

@Injectable()
export class FeaturePermissionProviderService extends IFeaturePermissionProviderService {
  protected featureCollectionDefinition: IFeatureCollection[] = [];
}
